import EventService from "../../services/EventService";
// import { indexById } from "../../components/Utils";
import { compareOrderWeight } from "../../components/Utils";
import { addAppointmentFields } from "@/utils/Item";

export const namespaced = true;


export const state = {
    loading: -1,  // Initial no-load state
    appointments: [],
    // byId: {}
};

export const mutations = {
    SET_LOADING(state, percent) {
        state.loading = percent;
    },
    SET_APPOINTMENTS(state, appointments) {
        state.appointments = appointments;
    },
    // SET_BYID(state, indexed) {
    //     state.byId = indexed;
    // }
};

export const actions = {
    async fetchAppointments(context) {
        context.commit('SET_LOADING', 0);
        return EventService.getMyAppointments()
            .then(response => {
                context.commit('SET_LOADING', 50);
                let data = response.data.map(addAppointmentFields);
                context.commit('SET_APPOINTMENTS', data);
                // context.commit('SET_APPOINTMENTS', response.data);
                // context.commit('SET_BYID', indexById(response.data));
                context.commit('SET_LOADING', 100);
            })
            .catch(error => {
               console.log('getAppointments failed: ', error.message)
               context.commit('SET_LOADING', 101); // Error state
               throw new Error('Could not load appointments');
            });
    },
    reset(context) {
        context.commit('SET_LOADING', -1);
        context.commit('SET_APPOINTMENTS', []);
        // context.commit('SET_BYID', {});
    }
};

export const getters = {
    // Use THIS getter and let the Components decide what to do with it all!
    all: (state) => {
        return state.appointments;
    },
    
    // Get all the appointments that are not hidden
    // hidden == Not in schedule, or No track_id
    visible: (state) => {
        return state.appointments.filter(appointment => (
            appointment.in_schedule ||
            appointment.track_id
        ));
    },
    // Appointments to be shown in the Schedule View
    // i.e. My ticketed Appointments + any flagged as "in_schedule"
    scheduled: (state) => {
        return state.appointments.filter(appointment => (
            appointment.in_schedule ||
            (Object.prototype.hasOwnProperty.call(appointment, 'appointment_attendees'))
        ));
    },
    appointmentsByDay: (state) => {
        const appointments = [];
        for (let i=0, max = state.appointments.length; i<max; i++) {
            let appointment = state.appointments[i];
            if (!appointment.in_schedule && !appointment.track_id) { continue; } // Hidden appointment

            if (! (appointment.day in appointments)) {
                appointments[appointment.day] = [];
            }
            appointments[appointment.day].push(appointment);
        }

        return appointments;
    },
    // Filter the available appointments to find any tracks embedded in them
    tracks: (state) => {
        const track_ids = [];
        return state.appointments.reduce( (out, appointment) => {
            if (appointment.track_id && !track_ids.includes(appointment.track_id)) {
                out.push({
                    id: appointment.track_id,
                    trackKey: appointment.trackKey,
                    name: appointment.track_name,
                    description: appointment.track_description,
                    order_weight: appointment.track_order,
                });
                track_ids.push(appointment.track_id);
            }
            return out;
        }, []).sort(compareOrderWeight);
    },
};